module.exports = __webpack_public_path__ + "static/img/showroomRight.a5718ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroomRight.png
// module id = PH38
// module chunks = 2